// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33b3H","rootNoMargin":"styles_rootNoMargin__lpQTp"};